var _rect, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatesicon43Cffd8A(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F0F5F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1303 8C14.2402 8 10.3812 14.2963 13.2247 19.5771L20.1303 32.779L27.0359 19.5771C29.8794 14.2963 26.0204 8 20.1303 8ZM19.9272 20.1864C17.2868 20.1864 15.0527 18.1553 15.0527 15.5149C15.0527 12.8746 17.2868 10.6404 19.9272 10.6404C22.5676 10.6404 24.8018 12.8746 24.8018 15.5149C24.8018 18.1553 22.5676 20.1864 19.9272 20.1864Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1303 8C14.2402 8 10.3812 14.2963 13.2247 19.5771L20.1303 32.779L27.0359 19.5771C29.8794 14.2963 26.0204 8 20.1303 8ZM19.9272 20.1864C17.2868 20.1864 15.0527 18.1553 15.0527 15.5149C15.0527 12.8746 17.2868 10.6404 19.9272 10.6404C22.5676 10.6404 24.8018 12.8746 24.8018 15.5149C24.8018 18.1553 22.5676 20.1864 19.9272 20.1864Z",
    fill: "url(#paint0_linear_11310_23653)",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1303 8C14.2402 8 10.3812 14.2963 13.2247 19.5771L20.1303 32.779L27.0359 19.5771C29.8794 14.2963 26.0204 8 20.1303 8ZM19.9272 20.1864C17.2868 20.1864 15.0527 18.1553 15.0527 15.5149C15.0527 12.8746 17.2868 10.6404 19.9272 10.6404C22.5676 10.6404 24.8018 12.8746 24.8018 15.5149C24.8018 18.1553 22.5676 20.1864 19.9272 20.1864Z",
    fill: "url(#paint1_linear_11310_23653)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11310_23653",
    x1: 27.9911,
    y1: 32.779,
    x2: 5.57263,
    y2: 18.5551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11310_23653",
    x1: 12.2695,
    y1: 8,
    x2: 34.4427,
    y2: 22.3413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatesicon43Cffd8A);
export default __webpack_public_path__ + "static/media/statesicon.43cffd8a.97eaece8693a3627c5ea94fd01655638.svg";
export { ForwardRef as ReactComponent };